import { render, staticRenderFns } from "./dosAndDonts.vue?vue&type=template&id=66981f98"
import script from "./dosAndDonts.vue?vue&type=script&lang=js"
export * from "./dosAndDonts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports